<nz-form-item>
  <span>{{ label }}</span>
  <nz-form-control [nzValidateStatus]="convertErrorsNz[inputFormControl.status]">
    <nz-date-picker
      #datePicker
      nz-tooltip
      [nzTooltipTitle]="tooltipTitle"
      (click)="onOpenDatePicker(datePicker)"
      (keydown.enter)="onOpenDatePicker(datePicker)"
      [disabled]="inputFormControl.disabled"
      [nzDisabled]="readonly"
      class="tw-w-full"
      [name]="controlName"
      ngDefaultControl
      [ngModel]="date"
      [nzFormat]="formatDate"
      (ngModelChange)="onChangeDate($event)"
    ></nz-date-picker>
    <app-form-item-error [touched]="inputFormControl.touched" [errors]="inputFormControl.errors"></app-form-item-error>
  </nz-form-control>
</nz-form-item>
